import { ExtractedArticleInformationType } from "../types/ExtractedArticleInformationType";

export function extractProductInformationFromITF(
  barcode: string
): ExtractedArticleInformationType {
  if (barcode.length !== 14) {
    throw new Error(`NOT_14_DIGITS, Barcode : ${barcode}`);
  }
  return {
    articleNumber: barcode.substring(0, 8),
    supplierNumber: barcode.substring(8, 13),
    dateStamp: "",
  };
}

export function extractProductInformationFromEAN13(
  barcode: string
): ExtractedArticleInformationType {
  return {
    articleNumber: barcode.substring(1, 9),
    supplierNumber: "",
    dateStamp: "",
  };
}

export function extractProductInformationFromUPC(
  barcode: string
): ExtractedArticleInformationType {
  return {
    articleNumber: barcode.substring(3, 11),
    supplierNumber: barcode.substring(0, 3),
    dateStamp: "",
  };
}

export function extractProductInformationFromFoodArticleNumber(
  barcode: string
): ExtractedArticleInformationType {
  return {
    articleNumber: barcode.substring(1, 9),
    supplierNumber: barcode.substring(0, 1),
    dateStamp: "",
  };
}

export function extractProductInformationFromArticleNumber(
  articleNumber: string
): ExtractedArticleInformationType {
  return {
    articleNumber,
    supplierNumber: "",
    dateStamp: "",
  };
}

export function extractProductInformationFromDataMatrix(
  url: string
): ExtractedArticleInformationType {
  // Sentry error shows that some URLs can be in this format:
  // https://www.goto.ikea.com/240/40174215231419

  const regex = /\/(\d{8})(\d{5})\d(?:\?|$)/;
  const match = url.match(regex);
  if (!match) {
    const sanitizedUrl = new URL(url);
    console.log(`NO_PRODUCT_ID_FOUND in URL : ${url}`);
    throw new Error(
      `NO_PRODUCT_ID_FOUND in URL: ${sanitizedUrl.origin}${sanitizedUrl.pathname}`
    );
  }
  const parsedUrl = new URL(url);
  const dateStamp = parsedUrl.searchParams.get("13") ?? "";
  return {
    articleNumber: match[1] ?? "",
    supplierNumber: match[2] ?? "",
    dateStamp,
  };
}

export function extractProductInformationFromQrCode(
  url: string
): ExtractedArticleInformationType {
  // Sentry error shows that some URLs can be in this format:
  // https://ptag-info.ikea.com/?ct=sto&cc=456&in=30256891&it=ART&t=b6&s=q&p=A

  const parsedUrl = new URL(url);
  return {
    articleNumber: parsedUrl.searchParams.get("in") ?? "",
    supplierNumber: parsedUrl.searchParams.get("cc") ?? "",
    dateStamp: "",
  };
}
